module.exports = __webpack_public_path__ + "img/lv0.460987c1.png";